<div class="kelvin-container d-flex align-items-center ml-3" [style.border-left]="'6px solid '+borderColor">
    <input
        type="number"
        [min]="minKelvin"
        [max]="maxKelvin"
        [value]="currentKelvin"
        (blur)="onKelvinChange($event)"
        (change)="onKelvinChange($event)"
        (wheel)="onKelvinChange($event)"
    />
    <span>K</span>
</div>
